export default __webpack_public_path__ + "static/media/p1i.03207449.jpg";